import { IDB_TRUE } from "@data/idb";
import { superCache } from "hooks/data/superCache";
import { useEffect, useState } from "react";
import DeckScreen from "./deck/deck";
import DeckDownloadScreen from "./deckDownload";

// Universal deck handler that works for both local and remote decks
export default function UniversalDeckScreen({ deckID, history }: { deckID: string; history: any }) {
  const [isLocal, setIsLocal] = useState(superCache.decks?.get(deckID)?.local === IDB_TRUE);
  useEffect(() => {
    function handleDeckUpdated({ ID }: { ID: string }) {
      if (ID === deckID) {
        setIsLocal(superCache.decks?.get(deckID)?.local === IDB_TRUE);
      }
    }
    superCache.events.on("deckUpdated", handleDeckUpdated);
    return () => {
      superCache.events.off("deckUpdated", handleDeckUpdated);
    };
  });

  if (isLocal) {
    return <DeckScreen deckID={deckID} history={history} />;
  }

  return (
    <DeckDownloadScreen
      deckID={deckID}
      history={history}
      dismiss={() => null} // Screen will auto-update in response to deck downloading (triggers a superCache update).
      onDownloadSuccess={() => null} // Screen will auto-update in response to deck downloading (triggers a superCache update).
    />
  );
}
